

(() => {
    window.contactMapLoaded = false; // Renamed flag to handle contact map specifically

    const isInViewport = (el, percentVisible) => {
        if (!el) return false;

        let rect = el.getBoundingClientRect(),
            windowHeight =
                window.innerHeight || document.documentElement.clientHeight;

        return !(
            Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) <
            percentVisible ||
            Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) <
            percentVisible
        );
    };

    const loadMap = () => {
        if (
            window.contactMapLoaded ||
            !isInViewport(document.querySelector("[data-map-holder-contact]"), 4)
        )
            return;

        window.contactMapLoaded = true; // Set contact-specific flag
        if (!window.wpObject?.gMapsApi) {
            console.error("Nemáte vyplněný API klíč pro Google Maps.");
            return;
        }

        const gMapsJs = document.createElement("script");
        gMapsJs.src = `https://maps.googleapis.com/maps/api/js?key=${window.wpObject.gMapsApi}&callback=initMap&libraries=&v=weekly`;

        document.body.insertAdjacentElement("beforeend", gMapsJs);
    };

    document.addEventListener("DOMContentLoaded", loadMap);
    document.addEventListener("scroll", loadMap);
    window.loadMap = loadMap;
})();

const initMap = () => {
    const mapEl = document.querySelector("[data-map-holder-contact]") as HTMLElement;
    if (!mapEl) return;

    const officeCoordinates = window.wpObject.mapPosition
            .replace(" ", "")
            .split(","),
        officeAddress = {
            lat: parseFloat(officeCoordinates[0] ?? "0"),
            lng: parseFloat(officeCoordinates[1] ?? "0"),
        };

    const mapCenter = {
        lat: officeAddress.lat,
        lng: officeAddress.lng,
    };


    const mapOffice = new google.maps.Map(mapEl, {
        center: mapCenter,
        zoom: 15,
        disableDefaultUI: true,
        styles: [
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "stylers": [
                    {
                        "hue": "#00aaff"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "gamma": 2.15
                    },
                    {
                        "lightness": 12
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "lightness": 24
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "lightness": 57
                    }
                ]
            }
        ]
    });

    const Icon = {
        url: `${window.location.origin}/wp-content/themes/elprocon/resources/icons/Pin.svg`,
        scaledSize: new google.maps.Size(75, 75),
    };


    const marker = new google.maps.Marker({
        position: officeAddress,
        map: mapOffice,
        icon: Icon,
    });

    marker.addListener("click", () => {
        window.open(`${window.wpObject.mapAddressUrl}`, "_blank");
    });

    mapOffice.addListener("tilesloaded", () =>
        mapEl.classList.remove("is-loading")
    );
};

declare global {
    interface Window {
        loadMap: () => void;
        initMap: () => void;
        mapLoaded: boolean;
        wpObject: {
            gMapsApi: string;
            mapPosition: string;
            mapAddressUrl: string;
            mapIcon: string;
            mapBackgroundColor: string;
            mapPrimaryColor: string;
        };
    }
}

window.initMap = initMap;
